import React from 'react';
import styled from 'styled-components';

const SummaryContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
`;

const SummaryCard = styled.div`
    background: #ffffff;
    border-radius: 12px;
    padding: 18px 22px;
    display: flex;
    align-items: center;
    gap: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 15px rgba(0,0,0,0.03);
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0,0,0,0.06);
    }
`;

const IconWrapper = styled.div`
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: ${props => props.bg || '#eff6ff'};
    color: ${props => props.color || '#2563eb'};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
`;

const CardLabel = styled.span`
    font-size: 13px;
    color: #64748b;
    font-weight: 600;
`;

const CardValue = styled.span`
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
`;

export default function HouseholdSummaryCards({ stats }) {
    return (
        <SummaryContainer>
            <SummaryCard>
                <IconWrapper bg="linear-gradient(135deg, #3b82f6, #60a5fa)" color="#fff">
                    <i className="fa fa-home"></i>
                </IconWrapper>
                <CardContent>
                    <CardLabel>Active Household Apiaries</CardLabel>
                    <CardValue>{(stats.totalHouseholdApiaries || 0).toLocaleString()}</CardValue>
                </CardContent>
            </SummaryCard>

            <SummaryCard>
                <IconWrapper bg="linear-gradient(135deg, #10b981, #34d399)" color="#fff">
                    <i className="fa fa-cubes"></i>
                </IconWrapper>
                <CardContent>
                    <CardLabel>Total Hives Count</CardLabel>
                    <CardValue>{(stats.totalHivesSum || 0).toLocaleString()}</CardValue>
                </CardContent>
            </SummaryCard>

            <SummaryCard>
                <IconWrapper bg="linear-gradient(135deg, #f59e0b, #fbbf24)" color="#fff">
                    <i className="fa fa-map-marker"></i>
                </IconWrapper>
                <CardContent>
                    <CardLabel>Mapped Locations</CardLabel>
                    <CardValue>{(stats.mappedLocationsCount || 0).toLocaleString()}</CardValue>
                </CardContent>
            </SummaryCard>
        </SummaryContainer>
    );
}
